<template>
  <lf-base-dialog
    v-model="visible"
    title="下载中心"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-confirm-button="false"
    :show-cancel-button="false"
    size="large"
    top="10vh"
    @close="handleCloseDialog"
  >
    <el-table
      v-loading="loading"
      :data="tableData"
      :cell-class-name="getCellClassName"
      max-height="60vh"
      border
    >
      <el-table-column
        label="文件名称"
        prop="fileName"
        show-overflow-tooltip
        fixed="left"
        min-width="130"
      />
      <el-table-column
        label="业务模块"
        prop="typeDesc"
        show-overflow-tooltip
        min-width="100"
      />
      <!-- <el-table-column
        label="总条数"
        prop="totalNum"
        show-overflow-tooltip
        align="right"
        width="80"
      /> -->
      <el-table-column
        label="状态"
        class-name="process-desc"
        prop="processDesc"
        show-overflow-tooltip
        width="80"
      />
      <el-table-column
        label="操作人"
        prop="operateUser"
        show-overflow-tooltip
        width="100"
      />
      <el-table-column
        label="操作时间"
        prop="processTime"
        show-overflow-tooltip
        width="160"
        :formatter="(row) => formatDate(row.processTime)"
      />
      <el-table-column
        label="操作"
        width="80"
        fixed="right"
      >
        <template #default="{ row }">
          <base-download-button
            :request="downloadRequestUrl"
            :query-params="{ objectName: row.objectName }"
            :link="true"
            type="primary"
            :disabled="row.processResult !== '1'"
          />
        </template>
      </el-table-column>
    </el-table>
    <base-pagination
      :page-num="pagination.pageNum"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <template #footer>
      <el-button @click="handleCloseDialog">关闭</el-button>
    </template>
  </lf-base-dialog>
</template>

<script setup lang="ts">
  import { ref, onUnmounted } from 'vue';

  import { useReportPage } from '@/hooks';
  import { DownloadInfoType, UsePageType } from '@/types';
  import { getDownloadsRequest, downloadRequestUrl } from '@/api/modules/common';
  import { useDateFormat } from '@vueuse/core';

  let myInterval:any = null;
  const emit = defineEmits(['closeDialog']);
  const visible = ref(false);

  const handleClearInterval = () => {
    if (myInterval) {
      clearInterval(myInterval);
    }
  };

  const {
    loading,
    page: pagination,
    tableData,
    handleSizeChange,
    handleCurrentChange,
  } = useReportPage({
    getListApi: getDownloadsRequest,
  }) as UsePageType<DownloadInfoType[]>;

  const handleOpenDialog = (): void => {
    visible.value = true;
    handleCurrentChange(1);

    myInterval = setInterval(() => {
      handleCurrentChange(pagination.pageNum, true);
    }, 60000);
  };

  const handleCloseDialog = () => {
    visible.value = false;
    handleClearInterval();
  };

  onUnmounted(() => {
    handleClearInterval();
  });

  const formatDate = (time: number| string) => (time ? useDateFormat(time, 'YYYY-MM-DD HH:mm:ss').value : '-');

  const statusMap:TypeObject = {
    0: 'warning',
    1: '',
    2: 'success',
    '-1': 'danger',
  };
  const getCellClassName = ({ column, row }:TypeObject) => {
    if (column.property === 'processDesc') {
      const status = row.processStatus;
      return statusMap[`${status}`];
    }
    return '';
  };

  defineExpose({
    handleOpenDialog,
    handleCloseDialog,
  });
</script>
